// @ts-nocheck
import { billingDocumentConfirmation } from '../../components/BillingDeliveries/billingDocumentStatus';
import {
  ADD_TIME_DIFFERENCE,
  ASSIGN_COORDINATOR_FAILURE,
  ASSIGN_COORDINATOR_REQUEST,
  ASSIGN_COORDINATOR_SUCCESS,
  FETCH_EVENT_DETAILS_FAILURE,
  FETCH_EVENT_DETAILS_STOP_LOADING,
  FETCH_EVENT_DETAILS_REQUEST,
  FETCH_EVENT_DETAILS_SUCCESS,
  REMOVE_COORDINATOR_FAILURE,
  REMOVE_COORDINATOR_REQUEST,
  REMOVE_COORDINATOR_SUCCESS,
  REMOVE_POSITION_FAILURE,
  REMOVE_POSITION_REQUEST,
  REMOVE_POSITION_SUCCESS,
  REMOVE_SESSION_FAILURE,
  REMOVE_SESSION_REQUEST,
  REMOVE_SESSION_SUCCESS,
  SUBMIT_ESTIMATE_FAILURE,
  SUBMIT_ESTIMATE_REQUEST,
  SUBMIT_ESTIMATE_SUCCESS,
  UPDATE_SESSION_POSITION_SUCCESS,
  UPDATE_SESSION_POSITION_REQUEST,
  UPDATE_SESSION_POSITION_FAILURE,
  UPDATE_SESSION_REQUEST,
  UPDATE_SESSION_SUCCES,
  UPDATE_SESSION_FAILURE,
  EVENT_EDITED_AFTER_ESTIMATE_REQUEST,
  EVENT_EDITED_AFTER_ESTIMATE_SUCCESS,
  EVENT_EDITED_AFTER_ESTIMATE_FAILURE,
  SET_EVENT_INFO,
  TOGGLE_SHOW_CONTRACTOR_INITIALS_REQUEST,
  TOGGLE_SHOW_CONTRACTOR_INITIALS_SUCCESS,
  TOGGLE_SHOW_CONTRACTOR_INITIALS_FAILURE,
  SET_FIELD_FOR_POSITION,
  FETCH_LOGS_REQUEST,
  FETCH_LOGS_SUCCESS,
  FETCH_LOGS_FAILURE,
  REFRESH_EVENT_REQUEST,
  REFRESH_EVENT_SUCCESS,
  REFRESH_EVENT_FAILURE,
  MARK_EVENT_COMPLETE_REQUEST,
  MARK_EVENT_COMPLETE_SUCCESS,
  MARK_EVENT_COMPLETE_FAILURE,
  ASSIGN_CONTRACTOR_REQUEST,
  ASSIGN_CONTRACTOR_SUCCESS,
  ASSIGN_CONTRACTOR_FAILURE,
  SEND_OPPORTUNITY_TO_CONTRACTORS_REQUEST,
  SEND_OPPORTUNITY_TO_CONTRACTORS_SUCCESS,
  SEND_OPPORTUNITY_TO_CONTRACTORS_FAILURE,
  FETCH_EVENT_DETAILS_POSITIONS_SUCCESS,
  ADD_NEW_POSITION_REQUEST,
  ADD_NEW_POSITION_SUCCESS,
  ADD_NEW_POSITION_FAILURE,
  FETCH_SCHEDULE_RESOURCES_REQUEST,
  FETCH_SCHEDULE_RESOURCES_SUCCESS,
  FETCH_SCHEDULE_RESOURCES_FAILURE,
  FETCH_CONTENT_RESOURCES_REQUEST,
  FETCH_CONTENT_RESOURCES_SUCCESS,
  FETCH_CONTENT_RESOURCES_FAILURE,
  UPLOAD_SCHEDULE_RESOURCES_REQUEST,
  UPLOAD_SCHEDULE_RESOURCES_SUCCESS,
  UPLOAD_SCHEDULE_RESOURCES_FAILURE,
  UPLOAD_CONTENT_RESOURCES_REQUEST,
  UPLOAD_CONTENT_RESOURCES_SUCCESS,
  UPLOAD_CONTENT_RESOURCES_FAILURE,
  DELETE_SCHEDULE_RESOURCES_REQUEST,
  DELETE_SCHEDULE_RESOURCES_SUCCESS,
  DELETE_SCHEDULE_RESOURCES_FAILURE,
  DELETE_CONTENT_RESOURCES_REQUEST,
  DELETE_CONTENT_RESOURCES_SUCCESS,
  DELETE_CONTENT_RESOURCES_FAILURE,
  DELETE_ALL_CONTENT_FILES_REQUEST,
  DELETE_ALL_CONTENT_FILES_SUCCESS,
  DELETE_ALL_CONTENT_FILES_FAILURE,
  DELETE_ALL_SCHEDULE_FILES_REQUEST,
  DELETE_ALL_SCHEDULE_FILES_SUCCESS,
  DELETE_ALL_SCHEDULE_FILES_FAILURE,
  CHANGE_ASSIGN_BY_REQUEST,
  CHANGE_ASSIGN_BY_SUCCESS,
  CHANGE_ASSIGN_BY_FAILURE,
  CHECK_SCHEDULE_CONFLICTS_FAILURE,
  CHECK_SCHEDULE_CONFLICTS_SUCCESS,
  APPROVE_TIME_REQUEST,
  APPROVE_TIME_SUCCESS,
  APPROVE_TIME_FAILURE,
  EVENT_DETAILS_TAB_SELECTED_SESSION,
  EVENT_DETAILS_TAB_SELECTED_PAGE,
  EVENT_REPORTED_TAB_SELECTED_SESSION,
  EVENT_REPORTED_TAB_SELECTED_PAGE,
  EVENT_ADD_NOTE_REQUEST,
  EVENT_ADD_NOTE_SUCCESS,
  EVENT_ADD_NOTE_FAILURE,
  SET_FIELD_VALUES_FOR_POSITIONS,
  CREATE_ESTIMATE_CONFIG_REQUEST,
  CREATE_ESTIMATE_CONFIG_SUCCESS,
  CREATE_ESTIMATE_CONFIG_FAILURE,
  UPDATE_ESTIMATE_CONFIG_REQUEST,
  UPDATE_ESTIMATE_CONFIG_SUCCESS,
  UPDATE_ESTIMATE_CONFIG_FAILURE,
  DELETE_ESTIMATE_CONFIG_REQUEST,
  DELETE_ESTIMATE_CONFIG_SUCCESS,
  DELETE_ESTIMATE_CONFIG_FAILURE,
  FETCH_ESTIMATE_CONFIG_REQUEST,
  FETCH_ESTIMATE_CONFIG_SUCCESS,
  FETCH_ESTIMATE_CONFIG_FAILURE,
  SUBMIT_ESTIMATE_CONFIG_REQUEST,
  SUBMIT_ESTIMATE_CONFIG_SUCCESS,
  SUBMIT_ESTIMATE_CONFIG_FAILURE,
  ACCEPT_ESTIMATE_CONFIG_REQUEST,
  ACCEPT_ESTIMATE_CONFIG_SUCCESS,
  ACCEPT_ESTIMATE_CONFIG_FAILURE,
  ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_REQUEST,
  ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_SUCCESS,
  ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_FAILURE,
  UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_REQUEST,
  UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_SUCCESS,
  UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_FAILURE,
  HALF_DAY_EVENT_CLICK_REQUEST,
  HALF_DAY_EVENT_CLICK_SUCCESS,
  HALF_DAY_EVENT_CLICK_FAILURE,
  HALF_DAY_POSITION_CLICK_REQUEST,
  HALF_DAY_POSITION_CLICK_SUCCESS,
  HALF_DAY_POSITION_CLICK_FAILURE,
  SUBMIT_INVOICE_CONFIG_REQUEST,
  SUBMIT_INVOICE_CONFIG_SUCCESS,
  SUBMIT_INVOICE_CONFIG_FAILURE,
  FETCH_INVOICE_CONFIG_FAILURE,
  FETCH_INVOICE_CONFIG_SUCCESS,
  FETCH_INVOICE_CONFIG_REQUEST,
  OVERRIDE_POSITION_CLICK_SUCCESS,
  UPDATE_SUBTOTAL_TYPE_REQUEST,
  UPDATE_SUBTOTAL_TYPE_SUCCESS,
  UPDATE_SUBTOTAL_TYPE_FAILURE,
  FETCH_REIMBURSEMENT_CATEGORY_REQUEST,
  FETCH_REIMBURSEMENT_CATEGORY_SUCCESS,
  FETCH_REIMBURSEMENT_CATEGORY_FAILURE,
  DELETE_REIMBURSEMNET_CATEGORY_REQUEST,
  DELETE_REIMBURSEMNET_CATEGORY_SUCCESS,
  DELETE_REIMBURSEMNET_CATEGORY_FAILURE,
  ADD_REIMBURSEMENT_CATEGORY_REQUEST,
  ADD_REIMBURSEMENT_CATEGORY_SUCCESS,
  ADD_REIMBURSEMENT_CATEGORY_FAILURE,
  GET_REIMBURSEMENT_AMOUNT_REQUEST,
  GET_REIMBURSEMENT_AMOUNT_SUCCESS,
  GET_REIMBURSEMENT_AMOUNT_FAILURE,
  SUBMIT_INVOICE_DATA_REQUEST,
  SUBMIT_INVOICE_DATA_SUCCESS,
  SUBMIT_INVOICE_DATA_FAILURE,
  GET_INVOICE_DATA_REQUEST,
  GET_INVOICE_DATA_FAILURE,
  GET_ALL_INVOICE_REQUEST,
  GET_ALL_INVOICE_SUCCESS,
  GET_ALL_INVOICE_FAILURE,
  GET_INVOICE_DATA_SUCCESS,
  DISMISS_CLIENT_CHANGES_REQUEST,
  DISMISS_CLIENT_CHANGES_SUCCESS,
  DISMISS_CLIENT_CHANGES_FAILURE,
  FETCH_SUBMITTED_INVOICE_REQUEST,
  FETCH_SUBMITTED_INVOICE_FAILURE,
  FETCH_SUBMITTED_INVOICE_SUCCESS,
  SWITCH_INVOICE_CONFIG,
  GET_DEPOSIT_INVOICE_AMOUNT_REQUEST,
  GET_DEPOSIT_INVOICE_AMOUNT_FAILURE,
  GET_DEPOSIT_INVOICE_AMOUNT_SUCCESS,
  ADD_EXTRA_EMAIL_REQUEST,
  ADD_EXTRA_EMAIL_SUCCESS,
  ADD_EXTRA_EMAIL_FAILURE,
  REMOVE_EXTRA_EMAIL_REQUEST,
  REMOVE_EXTRA_EMAIL_SUCCESS,
  REMOVE_EXTRA_EMAIL_FAILURE,
  POSITION_TERM_UPDATE_REQUEST,
  POSITION_TERM_UPDATE_SUCCESS,
  POSITION_TERM_UPDATE_FAILURE,
  CLEAR_CONTRACTOR_DIFFERENT_TIME,
  UNASSIGN_CONTRACTOR_REQUEST,
  UNASSIGN_CONTRACTOR_SUCCESS,
  UNASSIGN_CONTRACTOR_FAILURE,
  CALIFORNIA_CONTRACTOR_RATE_EVENT_REQUEST,
  CALIFORNIA_CONTRACTOR_RATE_EVENT_SUCCESS,
  CALIFORNIA_CONTRACTOR_RATE_EVENT_FAILURE,
  ASSIGN_COORDINATOR_META_DATA,
  SESSION_MANAGEMENT_META_DATA,
  REFRESH_RATE_LIST_FOR_EVENT_SUCCESS,
  REFRESH_RATE_LIST_FOR_EVENT_FAILURE,
  REFRESH_RATE_LIST_FOR_EVENT_REQUEST,
  ADD_UPDATE_CLIENT_CONTRACTOR_RATE_REQUEST,
  ADD_UPDATE_CLIENT_CONTRACTOR_RATE_SUCCESS,
  ADD_UPDATE_CLIENT_CONTRACTOR_RATE_FAILURE,
  OVERRIDE_POSITION_CLICK_REQUEST,
  OVERRIDE_POSITION_CLICK_FAILURE,
  UPDATE_PO_UPDATE_NEEDED_KEY,
} from '../constants/eventRequestDetails';
import { apiRequest } from '../../services/apiService';
import {
  REFRESH_POSITIONS_FAILURE,
  REFRESH_POSITIONS_REQUEST,
  REFRESH_POSITIONS_SUCCESS,
  UPDATE_DEPOSIT_INVOICE_STATUS_FAILURE,
  UPDATE_DEPOSIT_INVOICE_STATUS_REQUEST,
  UPDATE_DEPOSIT_INVOICE_STATUS_SUCCESS,
} from '../constants/eventRequest';
import { ALERT_DIALOG } from '../constants/auth';
import { addEditLogAction, addLogAction } from './logs';
import { alertDialogAciton, alertDialogCloseAction } from './auth';
import {
  ACCEPT_REIMBURSEMENT_FAILURE,
  ACCEPT_REIMBURSEMENT_REQUEST,
  ACCEPT_REIMBURSEMENT_SUCCESS,
  CLAIM_REIMBURSEMENT_FAILURE,
  CLAIM_REIMBURSEMENT_REQUEST,
  CLAIM_REIMBURSEMENT_SUCCESS,
  REJECT_REIMBURSEMENT_FAILURE,
  REJECT_REIMBURSEMENT_REQUEST,
  REJECT_REIMBURSEMENT_SUCCESS,
} from '../constants/schedule';
import {
  APPLY_OPPORTUNITY_FAIL,
  APPLY_OPPORTUNITY_REQUEST,
  APPLY_OPPORTUNITY_SUCCESS,
} from '../constants/opportunities';
import { isUserRole, isActiveRole } from '../../utils/methods/storeFunc';
import { USER_ROLES } from '../../staticData/userRoles';
import { GET_ESTIMATES_OF_CONFIG_SUCCESS } from '../constants/estimateData';
import { fetchDepositInvoiceHistoryAction } from './depositInvoice/depositInvoice';
import { getMergedEventTerms } from '../../utils/methods/estimate/estimateMethods';
import { normalizeInvoiceConfigResponse } from '../../utils/methods/invoiceConfigResponse';
import {
  GET_DEDUCTION_AMOUNT_FAILURE,
  GET_DEDUCTION_AMOUNT_REQUEST,
  GET_DEDUCTION_AMOUNT_SUCCESS,
} from '../constants/event/adjustments';
import { store } from '../store';
import { generateDateTableForReimWarning } from '../../utils/styles/defaultStyles';
import _, { isArray } from 'lodash';

async function fetchEventInfo(eventId) {
  const { response, error } = await apiRequest({
    method: 'GET',
    url: `getEventInformation/${eventId}`,
    data: null,
    isToken: true,
  });

  if (response?.status === 200) {
    return { response: response?.data?.data, error };
  } else if (response?.status !== 200 || error) {
    return { response, error };
  }
}

async function setCoordinatorForEvent(eventId, coordinatorId) {
  const { response, error } = await apiRequest({
    method: 'PATCH',
    url: `assignCoordinator/${eventId}`,
    data: {
      assignCoordinatorId: coordinatorId,
    },
    isToken: true,
  });

  if (response?.status === 200) {
    const { response: coordinatorInfo, error: fetchCoordinatorError } =
      await getCoordinatorById(coordinatorId);
    if (!fetchCoordinatorError) {
      return { response: coordinatorInfo, error };
    } else {
      return { response, error: fetchCoordinatorError };
    }
  } else if (response?.status !== 200 || error) {
    return { response, error };
  }
}

async function getCoordinatorById(coordinatorId) {
  const { response, error } = await apiRequest({
    method: 'GET',
    url: `getCoordinator/${coordinatorId}`,
    data: null,
    isToken: true,
  });
  if (response?.status === 200) {
    // pot those in coordinator array
    return {
      response: {
        ...response?.data?.data,
        _id: response?.data?.data?._id || response?.data?.data?.id,
      },
      error,
    };
  } else if (response?.status !== 200 || error) {
    return { response, error };
  }
}

// async function getSessions(eventId) {
//   const { response, error } = await apiRequest({
//     method: "GET",
//     url: `getSessionsOfSpecificEvent/${eventId}`,
//     data: null,
//     isToken: true,
//     version: "v3",
//   });
//
//   if (response?.status === 200) {
//     // set the sessions
//     const updatedResponse = response?.data?.data?.sort(
//       (a, b) => Date.parse(a?.createdAt) - Date.parse(b?.createdAt),
//     );
//
//     // get the positions
//     let allPositions = {};
//     let sessionString = {};
//     let sessionStringWithoutBackup = {};
//
//     updatedResponse?.forEach((session) => {
//       session?.position?.forEach((position) => {
//         position?.positionData?.forEach((pos) => {
//           if (isArray(allPositions?.[session?._id])) {
//             allPositions?.[session?._id]?.push({
//               ...pos,
//               ...(pos?.outSourceContractorId
//                 ? {
//                     contractorMetaData: {
//                       contractorName: pos?.contractorName,
//                       email: pos?.email,
//                       mobile: pos?.mobile,
//                       preferredName: pos?.preferredName,
//                       isContractorFlagged: pos?.isContractorFlagged,
//                       remark: pos?.remark,
//                       thirdPartyContractorName: pos?.thirdPartyContractorName,
//                       thirdPartyPreferredName: pos?.thirdPartyPreferredName,
//                       contractorType: pos?.contractorType,
//                     },
//                     contractorName: pos?.outSourceContractorName,
//                     email: pos?.outSourceEmail,
//                     mobile: pos?.outSourceMobile,
//                     preferredName: pos?.outSourceContractorPreferredName,
//                     isContractorFlagged: pos?.outSourceIsContractorFlagged,
//                     remark: pos?.outSourceFlaggedRemark,
//                     thirdPartyContractorName: pos?.contractorName,
//                     thirdPartyPreferredName: pos?.preferredName,
//                     contractorType: pos?.outSourceContractorType,
//                   }
//                 : {}),
//               session: { _id: session?._id, sessionName: session?.sessionName },
//             });
//           } else {
//             allPositions[session?._id] = [];
//             allPositions[session?._id]?.push({
//               ...pos,
//               ...(pos?.outSourceContractorId
//                 ? {
//                     contractorMetaData: {
//                       contractorName: pos?.contractorName,
//                       email: pos?.email,
//                       mobile: pos?.mobile,
//                       preferredName: pos?.preferredName,
//                       isContractorFlagged: pos?.isContractorFlagged,
//                       remark: pos?.remark,
//                       thirdPartyContractorName: pos?.thirdPartyContractorName,
//                       thirdPartyPreferredName: pos?.thirdPartyPreferredName,
//                       contractorType: pos?.contractorType,
//                     },
//                     contractorName: pos?.outSourceContractorName,
//                     email: pos?.outSourceEmail,
//                     mobile: pos?.outSourceMobile,
//                     preferredName: pos?.outSourceContractorPreferredName,
//                     isContractorFlagged: pos?.outSourceIsContractorFlagged,
//                     remark: pos?.outSourceFlaggedRemark,
//                     thirdPartyContractorName: pos?.contractorName,
//                     thirdPartyPreferredName: pos?.preferredName,
//                     contractorType: pos?.outSourceContractorType,
//                   }
//                 : {}),
//               session: { _id: session?._id, sessionName: session?.sessionName },
//             });
//           }
//         });
//
//         sessionString[session?._id] = `${session?.positionCount} ${
//           session?.positionCount > 1 ? "Positions" : "Position"
//         } - ${session?.shiftCount} ${
//           session?.shiftCount > 1 ? "Shifts" : "Shift"
//         }`;
//         sessionStringWithoutBackup[session?._id] = `${
//           session?.totalPositionsCountWithoutBackup
//         } ${
//           session?.totalPositionsCountWithoutBackup > 1
//             ? "Positions"
//             : "Position"
//         } - ${session?.shiftCountWithoutBackup} ${
//           session?.shiftCountWithoutBackup > 1 ? "Shifts" : "Shift"
//         }`;
//       });
//     });
//
//     return {
//       response: {
//         sessions: updatedResponse,
//         positions: allPositions,
//       },
//       error,
//     };
//   } else if (response?.status !== 200 || error) {
//     return { response, error };
//   }
// }
async function getSessions(eventId) {
  const { response, error } = await apiRequest({
    method: 'GET',
    url: `getSessionsOfSpecificEvent/${eventId}`,
    data: null,
    isToken: true,
  });

  if (response?.status === 200) {
    const sortedSessions = response?.data?.data?.sort((a, b) => {
      return Date.parse(a?.createdAt) - Date.parse(b?.createdAt);
    });

    let allPositions = {};
    let sessionStrings = {};
    let sessionStringsWithoutBackup = {};

    const updatedResponse = sortedSessions?.map((session) => {
      if (!allPositions[session?._id]) {
        allPositions[session?._id] = [];
      }

      session?.position?.forEach((position) => {
        position?.positionData
          ?.sort((a, b) => {
            if (a?.startDate != b?.startDate) {
              return a?.startDate?.localeCompare(b?.startDate);
            } else if (a?.startDate == b?.startDate && a?.positionId == b?.positionId) {
              return a?.positionOrder - b?.positionOrder;
            } else return 0;
          })
          ?.forEach((pos) => {
            const positionCopy = {
              ...pos,
              ...(pos?.outSourceContractorId
                ? {
                    contractorMetaData: {
                      contractorName: pos?.contractorName,
                      email: pos?.email,
                      mobile: pos?.mobile,
                      preferredName: pos?.preferredName,
                      preferredname: pos?.preferredname,
                      isContractorFlagged: pos?.isContractorFlagged,
                      remark: pos?.remark,
                      isContractorRestricted: pos?.isContractorRestricted,
                      restrictedRemark: pos?.restrictedRemark,
                      thirdPartyContractorName: pos?.thirdPartyContractorName,
                      thirdPartyPreferredName: pos?.thirdPartyPreferredName,
                      contractorType: pos?.contractorType,
                    },
                    contractorName: pos?.outSourceContractorName,
                    email: pos?.outSourceEmail,
                    mobile: pos?.outSourceMobile,
                    preferredName: pos?.outSourceContractorPreferredName,
                    preferredname: pos?.outSourcepreferredName,
                    isContractorFlagged: pos?.outSourceIsContractorFlagged,
                    remark: pos?.outSourceFlaggedRemark,
                    isContractorRestricted: pos?.outSourceIsContractorRestricted,
                    restrictedRemark: pos?.outSourceRestrictedRemark,
                    thirdPartyContractorName: pos?.contractorName,
                    thirdPartyPreferredName: pos?.preferredName,
                    contractorType: pos?.outSourceContractorType,
                  }
                : {}),
              session: { _id: session?._id, sessionName: session?.sessionName },
            };

            allPositions[session?._id].push(positionCopy);
          });
      });

      sessionStrings[session._id] = `${session?.positionCount} ${
        session?.positionCount > 1 ? 'Positions' : 'Position'
      } - ${session?.shiftCount} ${session?.shiftCount > 1 ? 'Shifts' : 'Shift'}`;

      sessionStringsWithoutBackup[session._id] = `${session?.totalPositionsCountWithoutBackup} ${
        session?.totalPositionsCountWithoutBackup > 1 ? 'Positions' : 'Position'
      } - ${session?.shiftCountWithoutBackup} ${
        session?.shiftCountWithoutBackup > 1 ? 'Shifts' : 'Shift'
      }`;

      return { ...session };
    });

    return {
      response: {
        sessions: updatedResponse,
        positions: allPositions,
        sessionStrings: sessionStrings,
        sessionStringsWithoutBackup: sessionStringsWithoutBackup,
      },
      error,
    };
  } else if (response?.status !== 200 || error) {
    return { response, error };
  }
}

function getSortedPositons({ positions }) {
  const updatedPositions = _.cloneDeep(positions);

  let sortedPositions = {};

  Object.keys(positions)?.forEach((sessionId) => {
    sortedPositions[sessionId] = updatedPositions[sessionId]?.sort((a, b) =>
      a.startDate?.localeCompare(b.startDate),
    );
  });

  return sortedPositions;
}

async function deleteSession(sessionId, confirmPassword) {
  const { response, error } = await apiRequest({
    method: 'PATCH',
    url: `deleteSession/${sessionId}`,
    data: {
      confirmationPassword: confirmPassword,
    },
    isToken: true,
  });
  return { response, error };
}

async function deletePosition(eventId, sessionId, ppId, isAnyway) {
  // ppId: particular position id
  const { response, error } = await apiRequest({
    method: 'PUT',
    url: `deleteMultiplePositions`,
    params: {
      eventId,
    },
    data: {
      positions: [
        {
          sessionId,
          id: ppId,
        },
      ],
      anyway: isAnyway ? true : false,
    },
    isToken: true,
  });

  return { response, error };
}

// fetch event details
export const fetchEventDetailsAction = (payload) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EVENT_DETAILS_REQUEST });
    // IMPORTANT: use `isActiveRole` (the role currently active in the role switcher)
    // and NOT `isUserRole` (which is the OR-aggregate of ALL of the user's approvedRoles).
    // After the multi-role migration, superAdmin has every role approved —
    // `isUserRole(FREELANCE_EC, COORDINATOR)` became always true for superAdmin
    // → the fetch never fires → config stays null → on the Approved Estimate tab
    // these disappear: the "Event Estimate" tab, "Estimate Status: Estimate Approved",
    // and "Event updated after estimate submission".
    if (!isActiveRole(USER_ROLES.FREELANCE_EC)) {
      // Billing configurations are available to coordinators on assigned shows.
      dispatch(
        fetchEstimateConfigAction({
          payload: { params: { eventId: payload?.eventId } },
        }),
      );
    }

    function fetchDepositInvoice() {
      // additional api for client to fetch all deposit invoices
      dispatch(
        fetchDepositInvoiceHistoryAction({
          payload: {
            params: {
              eventId: payload?.eventId,
            },
          },
        }),
      );
    }

    function fetchinvoice(data) {
      if (isActiveRole(USER_ROLES.CLIENT)) {
        // dispatch(
        //   getInvoiceDataAction({
        //     payload: { params: { eventId: payload?.eventId } },
        //   }),
        // );
        dispatch(
          fetchSubmittedInvoiceAction({
            payload: {
              params: { eventId: payload?.eventId },
            },
          }),
        );
      }
      dispatch(
        fetchInvoiceConfigAction({
          payload: {
            params: {
              eventId: data?.eventInfo?._id,
            },
          },
        }),
      );
    }

    function fetchReimbursementAmount(data) {
      if (data?.eventInfo?.approved) {
        dispatch(
          getReimbursementAmountAction({
            payload: {
              params: {
                eventId: data?.eventInfo?._id,
              },
            },
          }),
        );
        dispatch(
          getDeductionAmountAction({
            payload: {
              params: {
                eventId: data?.eventInfo?._id,
              },
            },
          }),
        );
        dispatch(
          getDepositInvoiceAmountAction({
            payload: {
              params: {
                eventId: data?.eventInfo?._id,
              },
            },
          }),
        );
      }
    }

    let data = {
      eventInfo: null,
      contactInfo: null,
      coordinators: [],
      sessions: [],
      sessionString: {},
      sessionStringWithoutBackup: {},
      positions: {},
    };

    try {
      // NOTE: fetching event info
      const { response: eventInfo, error: fetchEventError } = await fetchEventInfo(payload.eventId);

      // 🔴 `apiRequest` NUNCA lança: `apiService.ts:103-155` engole o erro do axios e devolve
      // `{ response: null, error }`. Ou seja, um 403/500 NÃO chega no `catch` lá embaixo.
      // Antes deste `throw` o fluxo simplesmente seguia com `eventInfo` null, o
      // FETCH_EVENT_DETAILS_SUCCESS nunca era despachado e `isLoading` ficava `true` PARA
      // SEMPRE — a tela virava um spinner eterno e MUDO, indistinguível de "carregando".
      // Foi o chamado do Will Redenbaugh no Westin Boston (04/08): o cliente escreveu
      // "it never loads" e não havia mensagem nenhuma pra pedir a ele. Agora o erro aparece.
      if (fetchEventError) throw fetchEventError;

      {
        data.eventInfo = eventInfo;
        // NOTE: the preferred contact info comes from the BE's populated lookup
        // (`contactInformationId` is the doc with the real `_id`). We only fall back to
        // `contactFormData` (a legacy snapshot WITHOUT `_id`) if the populated value is
        // empty — otherwise the Edit Contact Information form ends up without an
        // `_id` and the submit throws a 400 "Valid contactId required".
        const populatedContact =
          typeof eventInfo?.contactInformationId === 'object' &&
          eventInfo?.contactInformationId !== null
            ? eventInfo.contactInformationId
            : null;
        data.contactInfo = populatedContact || eventInfo?.contactFormData;

        // NOTE: fetching coordinators
        // Legacy data sometimes stores `assignedCoordinatorId` as a single string
        // (1 coordinator) and sometimes as an array. Without this normalization,
        // `string.map(...)` throws a TypeError → the catch fires the "Error fetching
        // data" and the details page won't open (Future Event RJ).
        const rawCoordIds = eventInfo?.assignedCoordinatorId;
        const coordIds = Array.isArray(rawCoordIds)
          ? rawCoordIds
          : rawCoordIds
            ? [rawCoordIds]
            : [];
        await Promise.all(
          coordIds.map(async (cId) => {
            const { response: coordinator, error: fetchCoordinatorError } =
              await getCoordinatorById(cId);
            if (!fetchCoordinatorError) {
              data.coordinators.push(coordinator);
            } else if (fetchCoordinatorError) {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: 'Error',
                  message: 'Failed to fetch coordinator data',
                }),
              );
            }
          }),
        );
      }

      // NOTE: fetching contact info
      // const { response: contactInfo, error: fetchContactError } =
      //   await fetchContactInfo(eventInfo?.contactInformationId);
      // if (!fetchContactError) {
      //   data.contactInfo = contactInfo;
      // }

      // NOTE: fetching sessions
      const { response: sessionsResponse, error: fetchSessionsError } = await getSessions(
        payload.eventId,
      );
      // Mesma armadilha do evento acima: sem este `throw`, um erro aqui pulava o bloco
      // inteiro — e o SUCCESS morava DENTRO dele, então `isLoading` nunca voltava a false.
      if (fetchSessionsError) throw fetchSessionsError;

      {
        data.sessions = sessionsResponse?.sessions;
        data.positions = sessionsResponse?.positions;
        data.sessionString = sessionsResponse?.sessionStrings;
        data.sessionStringWithoutBackup = sessionsResponse?.sessionStringsWithoutBackup;

        // ⚠️ Era `if ((eventInfo, sessionsResponse))` — comma operator: avaliava só o 2º
        // operando e ignorava o 1º. Com o evento falhando e as sessions passando, o SUCCESS
        // ia com `eventInfo: null` e o 4º termo do gate da tela
        // (`eventInfo?._id !== state?.id`, EventDetailsClient.tsx:306) travava do mesmo
        // jeito, agora com TODAS as flags de loading em false. Os dois `throw` acima já
        // garantem que chegamos aqui só com os dois lados carregados.
        dispatch({
          type: FETCH_EVENT_DETAILS_SUCCESS,
          payload: {
            eventInfo: data.eventInfo,
            contactInfo: data.contactInfo,
            coordinators: data.coordinators,
            sessions: data.sessions,
          },
        });
        // await Promise.all(
        //   sessionsResponse?.map(async (session) => {
        //     const { response: positions, error: fetchPositionsError } =
        //       await getSessionPositions(session);
        //     if (!fetchPositionsError) {
        //       data.positions[session?._id] = positions?.positions;
        //       data.sessionString[session?._id] = positions?.sessionString;
        //       data.sessionStringWithoutBackup[session?._id] =
        //         positions?.sessionStringWithoutBackup;
        //     } else if (fetchPositionsError) {
        //       throw new Error("Error fetching positions");
        //     }
        //   }),
        // );
      }

      if (
        (isActiveRole(USER_ROLES.CLIENT) && data?.eventInfo?.markEventComplete) ||
        isUserRole(USER_ROLES.ADMIN, USER_ROLES.SUPERADMIN, USER_ROLES.COORDINATOR)
      ) {
        fetchinvoice(data);
      }

      if (isActiveRole(USER_ROLES.CLIENT)) {
        fetchDepositInvoice(data);
      }

      if (isUserRole(USER_ROLES.ADMIN, USER_ROLES.SUPERADMIN, USER_ROLES.COORDINATOR)) {
        fetchReimbursementAmount(data);
      }

      dispatch({
        type: FETCH_EVENT_DETAILS_POSITIONS_SUCCESS,
        payload: {
          positions: getSortedPositons({ positions: data?.positions }),
          sessionString: data?.sessionString,
          sessionStringWithoutBackup: data?.sessionStringWithoutBackup,
        },
      });

      // if ((eventInfo, contactInfo, sessions)) {
      //   dispatch({ type: FETCH_EVENT_DETAILS_SUCCESS, payload: data });
      // }
    } catch (error) {
      console.error('\n>>> error ', error);
      dispatch({ type: FETCH_EVENT_DETAILS_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message:
            error?.response?.data?.message ??
            // Erro de rede/HTTP sem corpo (403 do OwnershipService, 500, timeout): antes
            // caía no genérico "Error fetching data" e o suporte não sabia o que pedir.
            (error?.response?.status
              ? `Could not load this event (error ${error.response.status}). Please refresh; if it keeps happening, contact support.`
              : 'Error fetching data'),
        },
      });
    } finally {
      // Garante que o loader SEMPRE desliga. O SUCCESS e o FAILURE já fazem isso no caminho
      // normal (aqui vira no-op); isto cobre qualquer saída futura que escape dos dois.
      dispatch({ type: FETCH_EVENT_DETAILS_STOP_LOADING });
    }
  };
};

// assign Coordinator to event
export const assignCoordinatorToEventAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: ASSIGN_COORDINATOR_REQUEST });
    const { response, error } = await setCoordinatorForEvent(
      payload?.eventId,
      payload?.coordinatorId,
    );

    if (!error) {
      dispatch({ type: ASSIGN_COORDINATOR_SUCCESS, payload: response });
      if (successCallback) successCallback();
    } else if (error) {
      dispatch({ type: ASSIGN_COORDINATOR_FAILURE });
    }
  };
};

// remove session from event
export const removeSessionFromEventAction = ({
  payload,
  eventInfo,
  description,
  successCallback,
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: REMOVE_SESSION_REQUEST });
    const { response, error } = await deleteSession(payload?.sessionId, payload?.confirmPassword);

    if (response?.status === 200) {
      dispatch({ type: REMOVE_SESSION_SUCCESS, payload: payload?.sessionId });
      dispatch(
        addLogAction({
          id: eventInfo?._id,
          payload: {
            actionById: getState()?.auth?.userId,
            sessionId: payload?.sessionId,
            description,
          },
        }),
      );
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REMOVE_SESSION_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message: error?.response?.data?.message || 'Unable to delete session!',
        },
      });
    }
  };
};

// remove position from event's session
export const removePositionFromEventAction = ({
  payload,
  eventInfo,
  description,
  positionId,
  successCallback,
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: REMOVE_POSITION_REQUEST });
    const { response, error } = await deletePosition(
      payload?.eventId,
      payload?.sessionId,
      payload?.ppId,
      payload?.isAnyway,
    );

    if (response?.status === 200) {
      if (
        response?.data?.reimbursementAttached ||
        response?.data?.contractorReimbursementAttached
      ) {
        dispatch({ type: REMOVE_POSITION_FAILURE });
        dispatch(
          alertDialogAciton({
            open: true,
            title: 'Warning',
            message: generateDateTableForReimWarning({
              isReimb: response?.data?.reimbursementAttached || false,
              list: response?.data?.reimbursementAttachedPositions?.reimbursementAttachedPositions,
              message: response?.data?.reimbursementAttachedPositions?.message,
              isLastCont: response?.data?.contractorReimbursementAttached || false,
              contList:
                response?.data?.reimbursementAttachedToContractors
                  ?.reimbursementAttachedToContractors,
              lastContMessage: response?.data?.reimbursementAttachedToContractors?.message,
            }),
            okLabel: 'Delete Anyway',
            onOk: () => {
              dispatch(alertDialogCloseAction({}));
              dispatch(
                removePositionFromEventAction({
                  payload: { ...payload, isAnyway: true },
                  eventInfo,
                  description,
                  positionId,
                  successCallback,
                }),
              );
            },
            onClose: () => {
              if (successCallback) successCallback();
              dispatch(refreshPositionAction({ eventId: eventInfo?._id }));
            },
          }),
        );
        return;
      }

      dispatch({
        type: REMOVE_POSITION_SUCCESS,
        payload: { sessionId: payload?.sessionId, ppId: payload?.ppId },
      });

      dispatch(
        addLogAction({
          id: eventInfo?._id,
          payload: {
            actionById: getState()?.auth?.userId,
            positionId,
            description,
          },
        }),
      );
      if (successCallback) successCallback();
      dispatch(refreshPositionAction({ eventId: eventInfo?._id }));
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REMOVE_POSITION_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message: 'Unable to delete position',
        },
      });
    }
  };
};

// remove coordinator from event
export const removeCoordinatorAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: REMOVE_COORDINATOR_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `removeCoordinator/${payload?.eventId}`,
      data: {
        coordinatorId: payload.coordinatorId,
      },
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: REMOVE_COORDINATOR_SUCCESS,
        payload: payload.coordinatorId,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REMOVE_COORDINATOR_FAILURE });
    }
  };
};

// add time difference
export const addTimeDiffAction = (payload) => {
  return (dispatch) => {
    dispatch({ type: ADD_TIME_DIFFERENCE, payload: payload?.sessionId });
  };
};

// submit estimate action
export const submitEstimateAction = (payload, successCallback, failureCallback) => {
  return async (dispatch) => {
    // Guard: never fire the PATCH without a valid eventId — avoids
    // `addEventEstimate/undefined`, which on the backend becomes a CastError → 400/500.
    if (!payload?.eventId) {
      dispatch({ type: SUBMIT_ESTIMATE_FAILURE });
      if (failureCallback) failureCallback();
      return;
    }
    dispatch({ type: SUBMIT_ESTIMATE_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `addEventEstimate/${payload?.eventId}`,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: SUBMIT_ESTIMATE_SUCCESS, payload: payload?.data });
      dispatch(fetchEventDetailsAction({ eventId: payload?.eventId }));
      // dispatch(refreshEventAction({ eventId: payload?.eventId }));
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: SUBMIT_ESTIMATE_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// update deposit invoice status
export const updateDepositInvoiceStatusAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_DEPOSIT_INVOICE_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'updateDepositInvoiceStatus',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPDATE_DEPOSIT_INVOICE_STATUS_SUCCESS });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_DEPOSIT_INVOICE_STATUS_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

export const submitRevisedEstimateAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_ESTIMATE_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `revisedEventEstimateGenerated`,
      data: payload?.data,
      params: { ...payload?.params, eventId: payload?.eventId ?? payload?.params?.id },
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: SUBMIT_ESTIMATE_FAILURE });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: SUBMIT_ESTIMATE_FAILURE });
      if (failureCallback) failureCallback();
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Error',
          message: error?.response?.data?.message || 'Error submitting revised estimate!',
        }),
      );
    }
  };
};

// assign contracto to position
export const assignContractorToPositionAction = (payload, successCallback, failureCallback) => {
  return async (dispatch) => {
    dispatch({ type: ASSIGN_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `assignContractor/${payload?.sessionId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      if (response?.data?.success) {
        dispatch({ type: ASSIGN_CONTRACTOR_SUCCESS, payload });
      } else {
        dispatch({
          type: ASSIGN_CONTRACTOR_FAILURE,
          payload: {
            sessionId: payload?.sessionId,
            data: {
              Id: payload?.data?.Id,
            },
          },
        });
      }
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ASSIGN_CONTRACTOR_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message:
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            'Error assigning contractor!',
        },
      });
      if (failureCallback) failureCallback(error?.response?.data);
    }
  };
};

// assign contracto to position
export const assignContractorToPositionAnywayAction = (
  payload,
  successCallback,
  failureCallback,
) => {
  return async (dispatch) => {
    dispatch({ type: ASSIGN_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `assignContractorAnyway/${payload?.sessionId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: ASSIGN_CONTRACTOR_SUCCESS, payload });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ASSIGN_CONTRACTOR_FAILURE });
      if (error?.response?.data?.error !== 'This contractor is already assigned to the position') {
        dispatch({
          type: ALERT_DIALOG,
          payload: {
            open: true,
            title: 'Error',
            message:
              error?.response?.data?.error ||
              error?.response?.data?.message ||
              'Error assigning contractor!',
          },
        });
      }
    }
  };
};

// change assign by action
export const changeAssignByAciton = (payload, successCallback, failureCallback) => {
  return async (dispatch) => {
    dispatch({ type: CHANGE_ASSIGN_BY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: 'updateAssignedBy',
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: CHANGE_ASSIGN_BY_SUCCESS, payload });
      if (successCallback) successCallback();
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Success',
          message: 'Assign by changed successfully!',
        },
      });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CHANGE_ASSIGN_BY_FAILURE });
      if (failureCallback) failureCallback();
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message: error?.response?.data?.message || 'Error changing assign by!',
        },
      });
    }
  };
};

// function to refresh event
export const refreshEventAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: REFRESH_EVENT_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: `getEventInformation/${payload?.eventId}`,
      data: null,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: REFRESH_EVENT_SUCCESS,
        payload: {
          eventInfo: response?.data?.data,
        },
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REFRESH_EVENT_FAILURE });
    }
  };
};

// funciton to refresh positions
export const refreshPositionAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: REFRESH_POSITIONS_REQUEST });
    let positions = {};
    let dataSessions = [];
    let sessionString = {};
    let sessionStringWithoutBackup = {};

    try {
      const { response: sessionsResponse, error: fetchSessionError } = await getSessions(
        payload?.eventId,
      );
      if (!fetchSessionError) {
        dataSessions = sessionsResponse?.sessions;
        positions = sessionsResponse?.positions;
        sessionString = sessionsResponse?.sessionStrings;
        sessionStringWithoutBackup = sessionsResponse?.sessionStringsWithoutBackup;

        // await Promise.all(
        //   sessions?.map(async (session) => {
        //     const { response: newPositions, error: fetchPositionError } =
        //       await getSessionPositions(session);
        //     if (!fetchPositionError) {
        //       positions[session?._id] = newPositions?.positions;
        //       sessionString[session?._id] = newPositions?.sessionString;
        //       sessionStringWithoutBackup[session?._id] =
        //         newPositions?.sessionString;
        //     } else if (fetchPositionError) {
        //       throw new Error("Error fetching positions");
        //     }
        //   }),
        // );
      }
      if (sessionsResponse) {
        dispatch({
          type: REFRESH_POSITIONS_SUCCESS,
          payload: {
            positions: getSortedPositons({ positions }),
            sessions: dataSessions,
            sessionString,
            sessionStringWithoutBackup,
          },
        });
        if (!isUserRole(USER_ROLES.FREELANCE_EC, USER_ROLES.COORDINATOR)) {
          dispatch(
            fetchEstimateConfigAction({
              payload: { params: { eventId: payload?.eventId } },
            }),
          );
        }
        if (successCallback) successCallback();
      }
    } catch (error) {
      dispatch({ type: REFRESH_POSITIONS_FAILURE });
    }
  };
};

// update position
export const updatePositionOfSessionAction = ({
  initialValues,
  changedValues,
  positionId,
  description,
  payload,
  eventInfo,
  successCallback,
  noChange = false,
  loadingContinue = false,
  version = 'v3',
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_SESSION_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      // url: `updatePosition/${payload?.sessionId}`,
      url: `${version ? 'updateSessionsPosition' : 'updatePosition'}/${payload?.sessionId}`,
      data: payload?.data,
      isToken: true,
      version,
    });
    if (response?.status === 200) {
      if (!loadingContinue) {
        dispatch({ type: UPDATE_SESSION_POSITION_SUCCESS });
        dispatch(refreshPositionAction({ eventId: eventInfo?._id }));
      }
      if (!noChange) {
        dispatch(
          addEditLogAction({
            id: eventInfo?._id,
            payload: {
              actionById: getState()?.auth?.userId,
              sessionId: payload?.sessionId,
              positionId,
              description,
              previousValues: initialValues,
              updatedValues: changedValues,
            },
          }),
        );
      }
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_SESSION_POSITION_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message: error?.response?.data?.message || 'Error updating position!',
        },
      });
    }
  };
};

// update position
export const updatePositionOfMulSessionAction = ({
  initialValues,
  changedValues,
  description,
  editLogPayload,
  payload,
  eventInfo,
  successCallback,
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_SESSION_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'updateMulSessionsPosition',
      data: payload,
      params: {
        eventId: eventInfo?._id,
      },
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: UPDATE_SESSION_POSITION_SUCCESS });
      dispatch(refreshPositionAction({ eventId: eventInfo?._id }));
      dispatch(
        addEditLogAction({
          id: eventInfo?._id,
          payload: {
            logData: editLogPayload,
          },
          // payload: {
          //   actionById: getState()?.auth?.userId,
          //   eventId: eventInfo?._id,
          //   description,
          //   previousValues: initialValues,
          //   updatedValues: changedValues,
          // },
        }),
      );
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_SESSION_POSITION_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message: error?.response?.data?.message || 'Error updating position!',
        },
      });
    }
  };
};

// update session action
export const updateSessionAction = ({
  description,
  initialValues,
  changedValues,
  payload,
  eventInfo,
  successCallback,
}) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_SESSION_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: `updateSessionData/${payload?.sessionId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPDATE_SESSION_SUCCES });
      dispatch(
        addEditLogAction({
          id: eventInfo?._id,
          payload: {
            actionById: getState()?.auth?.userId,
            sessionId: payload?.sessionId,
            previosValues: initialValues,
            updatedValues: changedValues,
            description,
          },
        }),
      );
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_SESSION_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message: error?.response?.data?.message || 'Error updating session!',
        },
      });
    }
  };
};

// event edited after estimate is generated
export const eventEditedAfterEstimateAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: EVENT_EDITED_AFTER_ESTIMATE_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `isEventEditedAfterEstimate/${payload.eventId}`,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: EVENT_EDITED_AFTER_ESTIMATE_SUCCESS });
      dispatch({
        type: SET_EVENT_INFO,
        payload: {
          eventInfo: response?.data?.data,
        },
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: EVENT_EDITED_AFTER_ESTIMATE_FAILURE });
    }
  };
};

/**
 * updatePositionClientChargeAction — toggles the client charge
 * ("Complimentary") on/off for 1..N shifts (HANDOFF feature §1). Does NOT affect the
 * payment to the contractor.
 *
 * payload: {
 *   eventId,
 *   items: [{ sessionId, positionDataId }],
 *   isChargeable: boolean,   // desired new state
 *   scope: 'full' | 'otOnly',
 *   reason: string,          // required when isChargeable changes value
 * }
 *
 * On success: refetch the positions + trigger the SAME
 * "estimate changed / pending re-approval" state as adding a position.
 */
export const updatePositionClientChargeAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_SESSION_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: 'updatePositionClientCharge',
      data: {
        eventId: payload?.eventId,
        items: payload?.items,
        isChargeable: payload?.isChargeable,
        scope: payload?.scope,
        reason: payload?.reason,
      },
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: UPDATE_SESSION_POSITION_SUCCESS });
      // Refetch to reflect clientCharge on the rows (toggle/tooltip/value).
      dispatch(refreshPositionAction({ eventId: payload?.eventId }));
      // Same re-approval flow as "edit/add position".
      if (payload?.isEstimateGenerated) {
        dispatch(
          eventEditedAfterEstimateAction({
            eventId: payload?.eventId,
            data: { isEventEditedAfterEstimate: true },
          }),
        );
      }
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_SESSION_POSITION_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Error',
          message:
            error?.response?.data?.message || 'Error updating client charge for the position(s).',
        }),
      );
    }
  };
};

// toggle show contractor initials action
export const toggleContractorInitialsAction = (payload, successCallback) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_SHOW_CONTRACTOR_INITIALS_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `showContractorInitials/${payload?.eventId}`,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: TOGGLE_SHOW_CONTRACTOR_INITIALS_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: TOGGLE_SHOW_CONTRACTOR_INITIALS_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message: 'Error toggling contractor privacy setting.',
        },
      });
    }
  };
};

// set field for position
export const setFieldForPosition = (payload) => {
  return (dispatch) => {
    dispatch({ type: SET_FIELD_FOR_POSITION, payload: payload });
  };
};

// set field for positions
export const setFieldValuesForPositions = (payload) => {
  return (dispatch) => {
    dispatch({ type: SET_FIELD_VALUES_FOR_POSITIONS, payload: payload });
  };
};

// add new log
// export const createLogAction = (payload) => {
//   return async (dispatch) => {
//     dispatch({ type: CREATE_LOG_REQUEST });
//     const { response, error } = await apiRequest({
//       method: "PUT",
//       url: `addLog/${payload?.eventId}`,
//       data: payload?.data,
//       isToken: true,
//     });
//
//     if (response?.status === 200) {
//       dispatch({ type: CREATE_LOG_SUCCESS });
//       dispatch(fetchLogsAction({ eventId: payload?.eventId }));
//     } else if (response?.status !== 200 || error) {
//       dispatch({ type: CREATE_LOG_FAILURE });
//     }
//   };
// };

// fetch logs action
export const fetchLogsAction = (payload) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_LOGS_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: `getLogsOfSpecificEvent/${payload?.eventId}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_LOGS_SUCCESS,
        payload: [...(response?.data?.data?.logsData ?? [])].reverse(),
      });
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_LOGS_FAILURE });
    }
  };
};

export function markEventAsCompleteAction({ payload, successCallback, failureCallback }) {
  return async (dispatch) => {
    dispatch({ type: MARK_EVENT_COMPLETE_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `markEventComplete/${payload?.eventId}`,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      const { response: invoiceResponse, error: invoiceError } = await apiRequest({
        method: 'PUT',
        url: 'addInvoiceAmount',
        data: {
          invoiceAmount: payload?.invoiceAmount,
        },
        params: { eventId: payload?.eventId },
        isToken: true,
      });
      if (invoiceResponse?.status === 200) {
        dispatch({ type: MARK_EVENT_COMPLETE_SUCCESS, payload: payload?.data });
        if (successCallback) successCallback();
      } else if (invoiceResponse?.status !== 200 || invoiceError) {
        dispatch({ type: MARK_EVENT_COMPLETE_FAILURE });
        if (failureCallback) failureCallback();
      }
    } else if (response?.status !== 200 || error) {
      dispatch({ type: MARK_EVENT_COMPLETE_FAILURE });
    }
  };
}

export function sendOpportunityToContractorsAction({
  payload,
  eventId,
  sessionId,
  successCallback,
  failureCallback,
  afterRequestCallback,
}) {
  return async (dispatch) => {
    dispatch({ type: SEND_OPPORTUNITY_TO_CONTRACTORS_REQUEST });
    let requestConfig = {};
    // if (payload?.opportunityData?.length > 1) {
    requestConfig = {
      method: 'PUT',
      url: `sendOpportunityToMulSessions`,
      params: {
        eventId,
        // sessionId,
      },
      data: payload,
      isToken: true,
    };
    // } else {
    //   const newPayload = payload?.opportunityData[0];
    //   newPayload.sessionId = sessionId;
    //   requestConfig = {
    //     method: "PATCH",
    //     url: `sendOpportunity/${eventId}`,
    //     params: {
    //       eventId,
    //     },
    //     data: newPayload,
    //     isToken: true,
    //     version: "v3",
    //   };
    // }

    const { response, error } = await apiRequest(requestConfig);

    if (response?.status === 200) {
      dispatch({
        type: SEND_OPPORTUNITY_TO_CONTRACTORS_SUCCESS,
        // payload: payload?.data
      });

      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({
        type: SEND_OPPORTUNITY_TO_CONTRACTORS_FAILURE,
      });
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Error',
          message: error?.response?.data?.message,
        }),
      );

      if (failureCallback) {
        failureCallback({ error });
      }
    }

    if (afterRequestCallback) {
      afterRequestCallback();
    }
  };
}

export const sendOpportunityAnywayAction = ({
  payload,
  eventId,
  sessionId,
  successCallback,
  failureCallback,
  afterRequestCallback,
}) => {
  return async () => {
    let requestConfig = {};
    // if (payload?.opportunityData?.length > 1) {
    requestConfig = {
      method: 'PUT',
      url: `sendOpportunityAnywayMulSessions`,
      params: {
        eventId,
        // sessionId,
      },
      data: payload,
      isToken: true,
    };
    // } else {
    //   const newPayload = payload?.opportunityData[0];
    //   newPayload.sessionId = sessionId;
    //   requestConfig = {
    //     method: "PATCH",
    //     url: `sendOpportunityAnyway/${eventId}`,
    //     params: {
    //       eventId,
    //     },
    //     data: newPayload,
    //     isToken: true,
    //     version: "v3",
    //   };
    // }
    const { response, error } = await apiRequest(requestConfig);
    if (response?.status === 200) {
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      if (failureCallback) failureCallback(error?.response?.data);
    }

    if (afterRequestCallback) afterRequestCallback();
  };
};

export function updateContractorOpportunityAction({
  params,
  payload,
  // contractorId,
  successCallback,
  afterRequestCallback,
  failureCallback,
}) {
  return async (dispatch) => {
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `toggleOpportunityResponse`,
      data: payload,
      params,
      isToken: true,
    });

    if (response?.status === 200) {
      if (successCallback) {
        successCallback({
          response: response?.data,
        });
      }
    } else if (response?.status !== 200 || error) {
      //
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }

    if (afterRequestCallback) {
      afterRequestCallback();
    }
  };
}

// update response anyway from admin
export const updateResponseAnywayAdminAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: APPLY_OPPORTUNITY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `toggleOpportunityResponseAnyway`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: APPLY_OPPORTUNITY_SUCCESS, payload: payload?.id });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPLY_OPPORTUNITY_FAIL });
      if (failureCallback) failureCallback(error?.response?.data);
    }
  };
};

// add new position to session
export const addNewPositionAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: ADD_NEW_POSITION_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: `addPosition/${payload?.sessionId}`,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: ADD_NEW_POSITION_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_NEW_POSITION_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// fetch schedule resources data
export const fetchScheduleResourcesAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SCHEDULE_RESOURCES_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: `scheduleFiles/${payload?.eventId}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_SCHEDULE_RESOURCES_SUCCESS,
        payload: response?.data?.contentFiles,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_SCHEDULE_RESOURCES_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// fetch content resources data
export const fetchContentResourcesAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CONTENT_RESOURCES_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: `contentFiles/${payload?.eventId}`,
      data: payload?.formData,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_CONTENT_RESOURCES_SUCCESS,
        payload: response?.data?.contentFiles,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_CONTENT_RESOURCES_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// upload schedule resources data
export const uploadScheduleResourcesAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: UPLOAD_SCHEDULE_RESOURCES_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      // url to post files,
      url: `uploadScheduleFiles/${payload?.eventId}`,
      data: payload?.formData,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPLOAD_SCHEDULE_RESOURCES_SUCCESS });
      dispatch(
        fetchScheduleResourcesAction({
          payload: { eventId: payload?.eventId },
        }),
      );
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPLOAD_SCHEDULE_RESOURCES_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// upload content resources data
export const uploadContentResourcesAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: UPLOAD_CONTENT_RESOURCES_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      // url to post files,
      url: `uploadContentFiles/${payload?.eventId}`,
      data: payload?.formData,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPLOAD_CONTENT_RESOURCES_SUCCESS });
      dispatch(fetchContentResourcesAction({ payload: { eventId: payload?.eventId } }));
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPLOAD_CONTENT_RESOURCES_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// delete schedule resources data
export const deleteScheduleResourcesAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_SCHEDULE_RESOURCES_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `deleteScheduleFile?eventId=${payload?.eventId}&Id=${payload?.fileId}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: DELETE_SCHEDULE_RESOURCES_SUCCESS,
        payload: payload?.fileId,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_SCHEDULE_RESOURCES_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// delete content resources data
export const deleteContentResourcesAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_CONTENT_RESOURCES_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `deleteContentFile?eventId=${payload?.eventId}&Id=${payload?.fileId}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: DELETE_CONTENT_RESOURCES_SUCCESS,
        payload: payload?.fileId,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_CONTENT_RESOURCES_FAILURE });
      if (failureCallback) failureCallback({ message: error?.response?.data?.message });
    }
  };
};

// delete all content files
export const deleteAllContentFilesAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_ALL_CONTENT_FILES_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `deleteAllContentFiles?eventId=${payload?.eventId}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: DELETE_ALL_CONTENT_FILES_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_ALL_CONTENT_FILES_FAILURE });
      if (failureCallback) failureCallback({ message: error?.response?.data?.message });
    }
  };
};

// delete all schedule files
export const deleteAllScheduleFilesAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_ALL_SCHEDULE_FILES_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `deleteAllScheduleFiles?eventId=${payload?.eventId}`,
      data: null,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: DELETE_ALL_SCHEDULE_FILES_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_ALL_SCHEDULE_FILES_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// claim reimbursement
export const claimReimbursementAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: CLAIM_REIMBURSEMENT_REQUEST });
    const { error, response } = await apiRequest({
      method: 'PUT',
      url: `addReimbursement`,
      params: payload?.params,
      data: payload?.formData,
      isToken: true,
      // file: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: CLAIM_REIMBURSEMENT_SUCCESS,
        payload: {
          newData: response?.data?.positionDataToUpdate,
          id: payload?.params?.id,
          sessionId: payload?.params?.sessionId,
        },
      });
      if (successCallback) successCallback(response?.data?.positionDataToUpdate);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CLAIM_REIMBURSEMENT_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// accept reimbursement
export const acceptReimbursementAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: ACCEPT_REIMBURSEMENT_REQUEST });
    const { error, response } = await apiRequest({
      method: 'PUT',
      url: `updateReimbursement`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: ACCEPT_REIMBURSEMENT_SUCCESS,

        payload: {
          newData: response?.data?.positionDataToUpdate,
          id: payload?.params?.id,
          sessionId: payload?.params?.sessionId,
        },
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ACCEPT_REIMBURSEMENT_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// reject reimbursement
export const rejectReimbursementAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: REJECT_REIMBURSEMENT_REQUEST });
    const { error, response } = await apiRequest({
      method: 'PUT',
      url: `updateReimbursement`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: REJECT_REIMBURSEMENT_SUCCESS,
        payload: {
          newData: response?.data?.positionDataToUpdate,
          id: payload?.params?.id,
          sessionId: payload?.params?.sessionId,
        },
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REJECT_REIMBURSEMENT_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// check schedule conflicts
export const checkScheduleConflictsAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: `isContAssignedForSameDate`,
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: CHECK_SCHEDULE_CONFLICTS_SUCCESS,
      });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CHECK_SCHEDULE_CONFLICTS_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// approve time action
export const approveTimeAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: APPROVE_TIME_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: 'clientApprovedTimeChange',
      data: null,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: APPROVE_TIME_SUCCESS, payload: payload?.params });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: APPROVE_TIME_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Error',
          message: error?.response?.data?.message || 'Error approving time!',
        }),
      );
      if (failureCallback) failureCallback();
    }
  };
};

// fetch contractors list on client
export const fetchContractorsListForClient = ({
  payload,
  successCallback,
  failureCallback,
  afterAllCallback,
}) => {
  return async (dispatch) => {
    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getAssignedContractorsOfEventClient',
      params: payload,
      isToken: true,
    });

    if (response?.status === 200) {
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Error',
          message: error?.response?.data?.message ?? 'Failed to get contractor list',
        }),
      );
      if (failureCallback) failureCallback();
    }
    if (afterAllCallback) afterAllCallback();
  };
};

// set event details tab data
export const eventDetailsTabSelectedSessionAction = (sessionId) => {
  return {
    type: EVENT_DETAILS_TAB_SELECTED_SESSION,
    payload: sessionId,
  };
};

// set event details tab selected page
export const eventDetailsTabSelectedPageAction = (pageNo) => {
  return {
    type: EVENT_DETAILS_TAB_SELECTED_PAGE,
    payload: pageNo,
  };
};

// set event report tab data
export const eventReportTabSelectedSessionAction = (sessionId) => {
  return {
    type: EVENT_REPORTED_TAB_SELECTED_SESSION,
    payload: sessionId,
  };
};

// set event details tab selected page
export const eventReportTabSelectedPageAction = (pageNo) => {
  return {
    type: EVENT_REPORTED_TAB_SELECTED_PAGE,
    payload: pageNo,
  };
};
// Create add note action
export const addNoteAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: EVENT_ADD_NOTE_REQUEST });

    const { response, error } = await apiRequest({
      method: 'POST',
      url: 'addOneOnOneRoom',
      data: payload.data,
      isToken: true,
    });

    if ((response?.status === 201 || response?.status === 200) && response?.data) {
      dispatch({
        type: EVENT_ADD_NOTE_SUCCESS,
        payload: response.data,
      });
      if (successCallback) successCallback(response.data);
    } else {
      const errorMessage = error?.message || 'Failed to add note';
      dispatch({
        type: EVENT_ADD_NOTE_FAILURE,
        payload: errorMessage,
      });

      if (failureCallback) failureCallback(errorMessage);
    }
  };
};

//fetching assigned users

export const fetchAssignedUsers = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_ASSIGNED_USERS_REQUEST' });

    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getAssignedUsersOfEvent',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: 'FETCH_ASSIGNED_USERS_SUCCESS',
        payload: response.data,
      });
      if (successCallback) successCallback(response.data);
    } else {
      dispatch({
        type: 'FETCH_ASSIGNED_USERS_FAILURE',
        payload: error?.message || 'Failed to fetch assigned users',
      });
      if (failureCallback) failureCallback(error);
    }
  };
};

//fetch One On One Notes

// export const fetchOneOnOneNotes = ({ payload, successCallback, failureCallback }) => {
//   return async (dispatch) => {
//     dispatch({ type: 'FETCH_ONE_ON_ONE_NOTES_REQUEST' });

//     const { response, error } = await apiRequest({
//       method: 'GET',
//       version: 'v3',
//       url: 'getOneOnOneNotes',
//       params: payload?.params,
//       isToken: true,
//     });

//     if (response?.status === 200) {
//       console.log(response,"resssss")
//       dispatch({
//         type: 'FETCH_ONE_ON_ONE_NOTES_SUCCESS',
//         payload: response.data,
//       });
//       if (successCallback) successCallback(response.data);
//     } else {
//       dispatch({
//         type: 'FETCH_ONE_ON_ONE_NOTES_FAILURE',
//         payload: error?.message || 'Failed to fetch event notes users',
//       });
//       if (failureCallback) failureCallback(error);
//     }
//   };
// };

//fetch One On One Rooms

export const fetchOneOnOneRooms = ({
  payload,
  beforeCallback,
  afterCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    if (beforeCallback) {
      beforeCallback();
    }

    dispatch({ type: 'FETCH_ONE_ON_ONE_ROOMS_REQUEST' });

    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getOneOnOneRooms',
      params: payload?.params,
      // params:{eventId:'66368a0cf08ea88364728b0d'},
      isToken: true,
    });

    if (afterCallback) {
      afterCallback();
    }

    if (response?.status === 200) {
      dispatch({
        type: 'FETCH_ONE_ON_ONE_ROOMS_SUCCESS',
        payload: response.data,
      });
      if (successCallback) successCallback(response.data);
    } else {
      dispatch({
        type: 'FETCH_ONE_ON_ONE_ROOMS_FAILURE',
        payload: error?.message || 'Failed to fetch event notes users',
      });
      if (failureCallback) failureCallback(error);
    }
  };
};

//fetch mark note resolved
export const fetchMarkNoteResolved = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCH_MARK_NOTE_RESOLVED_REQUEST' });

    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: 'markNoteResolved',
      data: payload.data,
      params: payload?.params,
      isToken: true,
    });
    if (response) {
      dispatch({
        type: 'FETCH_MARK_NOTE_RESOLVED_SUCCESS',
        payload: response.data,
      });
      if (successCallback) successCallback(response.data);
    } else {
      dispatch({
        type: 'FETCH_MARK_NOTE_RESOLVED_FAILURE',
        payload: error?.message || 'Failed to fetch mark note resolved',
      });
      if (failureCallback) failureCallback(error);
    }
  };
};
// fetch estimate config
export const fetchEstimateConfigAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ESTIMATE_CONFIG_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: isActiveRole(USER_ROLES.CLIENT)
        ? 'getSubmittedConfiguredEstimateClient'
        : 'getSubmittedConfiguredEstimate',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_ESTIMATE_CONFIG_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_ESTIMATE_CONFIG_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Error',
          message: 'Failed to fetch the estimate configurations, please refresh the page.',
        }),
      );
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// get invoice config
export const fetchInvoiceConfigAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_INVOICE_CONFIG_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: isActiveRole(USER_ROLES.CLIENT)
        ? 'getInvoiceGeneratedConfiguredEstimate'
        : 'getSubmittedConfiguredEstimate',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_INVOICE_CONFIG_SUCCESS,
        payload: normalizeInvoiceConfigResponse(response?.data?.data),
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_INVOICE_CONFIG_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// create estimate config action
export const createEstimateConfigAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: CREATE_ESTIMATE_CONFIG_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'addConfiguredEstimate',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: CREATE_ESTIMATE_CONFIG_SUCCESS,
        payload: response?.data?.data,
      });
      if (!payload?.stopRefresh) {
        dispatch(fetchEstimateConfigAction({ payload }));
      }
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CREATE_ESTIMATE_CONFIG_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// update estimate config
export const updateEstimateConfigAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_ESTIMATE_CONFIG_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'editConfiguredEstimate',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: UPDATE_ESTIMATE_CONFIG_SUCCESS,
        payload: response?.data,
      });
      dispatch(fetchEstimateConfigAction({ payload }));
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_ESTIMATE_CONFIG_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// delete estimate config
export const deleteEstimateConfigAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_ESTIMATE_CONFIG_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'deleteConfiguredEstimate',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: DELETE_ESTIMATE_CONFIG_SUCCESS,
        payload: payload?.params?.configurationId,
      });
      dispatch(fetchEstimateConfigAction({ payload }));
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_ESTIMATE_CONFIG_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// submit estimate config
export const submitEstimateConfigAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch, getState) => {
    const actor = getState()?.auth?.userId;
    dispatch({ type: SUBMIT_ESTIMATE_CONFIG_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'updateConfiguredEstimateSubmission',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: SUBMIT_ESTIMATE_CONFIG_SUCCESS,
        payload: payload?.params?.configurationId,
      });
      dispatch(fetchEstimateConfigAction({ payload }));
      if (payload?.estimates) {
        dispatch(
          addLogAction({
            id: payload?.params?.eventId,
            payload: {
              actionById: getState()?.auth?.userId,
              description: `Estimate generated for ${payload?.estimates}`,
            },
          }),
        );
      }
      const role = String(getState()?.auth?.userRole ?? '').replace(/\s/g, '').toLowerCase();
      if (actor === getState()?.auth?.userId && ['superadmin', 'admin', 'coordinator'].includes(role)) {
        const message = await billingDocumentConfirmation({ eventId: payload?.params?.eventId,
          configurationId: payload?.params?.configurationId, kind: 'estimate',
          documentNumber: payload?.documentNumber, sendRequested: true });
        if (actor === getState()?.auth?.userId) dispatch(alertDialogAciton({ open: true, title: 'Estimate document status', message }));
      }
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: SUBMIT_ESTIMATE_CONFIG_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// submit invoice config
export const submitInvoiceConfigAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_INVOICE_CONFIG_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'updateConfiguredEstimateApproval',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: SUBMIT_INVOICE_CONFIG_SUCCESS,
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: SUBMIT_INVOICE_CONFIG_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// accept estimate config
export const acceptEstimateConfigAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: ACCEPT_ESTIMATE_CONFIG_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'updateConfiguredEstimateApproval',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: ACCEPT_ESTIMATE_CONFIG_SUCCESS,
        payload: payload?.params?.configurationId,
      });
      dispatch(fetchEstimateConfigAction({ payload }));
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ACCEPT_ESTIMATE_CONFIG_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// assign contractor to multiple positions
export const assignContractorToMulPositionAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: `assignMultipleContractors`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      let errorIds = [];
      const rdata = response?.data;
      if (
        response?.data?.warnings ||
        response?.data?.alreadyAssigned ||
        rdata?.scheduledConflict ||
        rdata?.prebookContractors ||
        rdata?.holdDownContractors ||
        rdata?.reimbursementAttached ||
        rdata?.contractorReimbursementAttached ||
        rdata?.backupConflictContractors ||
        rdata?.warnings?.message ||
        rdata?.hasRestrictedContractor
      ) {
        // errorIds = [
        //   ...(response?.data?.warnings?.contractors?.map((item) => item?.Id) ||
        //     []),
        //   ...(response?.data?.alreadyAssigned?.contractors?.map(
        //     (item) => item?.Id,
        //   ) || []),
        // ];
        errorIds = [
          ...(rdata?.warnings?.contractors?.map((item) => item?.Id) || []),
          ...(rdata?.alreadyAssigned?.contractors?.map((item) => item?.Id) || []),
          ...(rdata?.prebookContractors?.contractors?.map((item) => {
            // eslint-disable-next-line
            return item?.Id;
          }) || []),
          ...(rdata?.backupConflictContractors?.contractors?.map((item) => {
            // eslint-disable-next-line
            return item?.Id;
          }) || []),
          ...(rdata?.holdDownContractors?.contractors?.map((item) => {
            // eslint-disable-next-line
            return item?.Id;
          }) || []),
          ...(rdata?.reimbursementAttachedPositions?.reimbursementAttachedPositions?.map(
            (item) => item?.Id,
          ) || []),
          ...(rdata?.reimbursementAttachedToContractors?.reimbursementAttachedToContractors?.map(
            (item) => item?.Id,
          ) || []),
          ...(rdata?.restrictedContractors?.blockedPositions?.map((i) => i?.Id) || []),
        ];
      }
      dispatch({
        type: ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_SUCCESS,
        payload: { data: payload, errorIds },
      });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message:
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            'Error assigning contractor!',
        },
      });
      if (failureCallback) failureCallback();
    }
  };
};

// assign contractor to multiple positions anyway
export const assignContractorToMulPositionAnywayAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: `assignMultipleContractorsAnyway`,
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      let errorIds = [];
      if (response?.data?.warnings || response?.data?.alreadyAssigned) {
        errorIds = [
          ...(response?.data?.warnings?.contractors?.map((item) => item?.Id) || []),
          ...(response?.data?.alreadyAssigned?.contractors?.map((item) => item?.Id) || []),
        ];
      }
      dispatch({
        type: ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_SUCCESS,
        payload: { data: payload, errorIds },
      });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_FAILURE });
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message:
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            'Error assigning contractor!',
        },
      });
      if (failureCallback) failureCallback();
    }
  };
};

export const updateAssignByMulPositionsAciton = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch, getState) => {
    dispatch({ type: UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'updateAssignedBy',
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_SUCCESS, payload });
      if (successCallback) successCallback(response?.data?.message);
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Success',
          message: response?.data?.message || 'Assign by changed successfully!',
        },
      });
      dispatch(
        addLogAction({
          id: payload?.params?.eventId,
          payload: {
            actionById: getState()?.auth?.userId,
            positionIds: [...(payload?.positionIds || [])],
            userId: payload?.additionalData?.assignedBy,
            description: `${payload?.additionalData?.assignedByName} is added to assignedBy on ${payload?.positionIds?.length} Position(s).`,
          },
        }),
      );
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_FAILURE });
      if (failureCallback) failureCallback();
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          title: 'Error',
          message: error?.response?.data?.message || 'Error changing assign by!',
        },
      });
    }
  };
};

// get estimate config
export const getEstimateConfigAction = async ({ payload }) => {
  const { response, error } = await apiRequest({
    method: 'GET',
    url: isActiveRole(USER_ROLES.CLIENT)
      ? 'getSubmittedConfiguredEstimateClient'
      : 'getSubmittedConfiguredEstimate',
    params: payload?.params,
    isToken: true,
  });

  if (response?.status === 200) {
    return response?.data?.data?.configurations || [];
  } else if (response?.status !== 200 || error) {
    return null;
  }
};

// half day event click handler
export const halfDayEventClickAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({
      type: HALF_DAY_EVENT_CLICK_REQUEST,
      payload: payload?.data?.ids,
    });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: 'updateHalfDayHours',
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: HALF_DAY_EVENT_CLICK_SUCCESS,
        payload: { data: payload?.data?.ids, status: payload?.status },
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: HALF_DAY_EVENT_CLICK_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// half day position click handler
export const halfDayPosiitonClickAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({
      type: HALF_DAY_POSITION_CLICK_REQUEST,
      payload: payload?.data?.ids,
    });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: 'updateHalfDayHours',
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: HALF_DAY_POSITION_CLICK_SUCCESS,
        payload: { data: payload?.data?.ids, status: payload?.status },
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: HALF_DAY_POSITION_CLICK_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// override position click handler
export const overridePosiitonClickAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: OVERRIDE_POSITION_CLICK_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: 'updateHalfDayHours',
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: OVERRIDE_POSITION_CLICK_SUCCESS,
        payload: { data: payload?.data?.ids, status: payload?.status },
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: OVERRIDE_POSITION_CLICK_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// update sutotal type
export const updateInvoiceType = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_SUBTOTAL_TYPE_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'addInvoiceType',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: UPDATE_SUBTOTAL_TYPE_SUCCESS,
        payload: {
          configId: payload?.params?.configurationId,
          type: payload?.data?.invoiceType,
        },
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_SUBTOTAL_TYPE_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// fetch reimbursement category action
export const fetchReimbursementCategory = ({ successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_REIMBURSEMENT_CATEGORY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getReimbursementCategories',
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: FETCH_REIMBURSEMENT_CATEGORY_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_REIMBURSEMENT_CATEGORY_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// delete reimbursement category
export const deleteReimbursementCategory = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_REIMBURSEMNET_CATEGORY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'DELETE',
      url: 'deleteReimbursementCategory',
      params: payload?.params,
      isToken: true,
    });
    if (response?.status == 200) {
      dispatch({
        type: DELETE_REIMBURSEMNET_CATEGORY_SUCCESS,
        payload: payload?.data?.id,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_REIMBURSEMNET_CATEGORY_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// add reimbursement category
export const addReimbursementCategoryAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: ADD_REIMBURSEMENT_CATEGORY_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'addReimbursementCategory',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: ADD_REIMBURSEMENT_CATEGORY_SUCCESS });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_REIMBURSEMENT_CATEGORY_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// get reimbursement amount action
export const getReimbursementAmountAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: GET_REIMBURSEMENT_AMOUNT_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getAdminReimbursementAmount',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: GET_REIMBURSEMENT_AMOUNT_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback(response?.data?.data ?? response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_REIMBURSEMENT_AMOUNT_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// get deduction amount action
export const getDeductionAmountAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: GET_DEDUCTION_AMOUNT_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getAdminDeductionAmount',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: GET_DEDUCTION_AMOUNT_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback(response?.data?.data ?? response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_DEDUCTION_AMOUNT_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

export const updateEstimatePONumber = ({ configId, poNumber }) => {
  return {
    type: 'UPDATE_ESTIMATE_PO_NUMBER',
    payload: { configId, poNumber },
  };
};

export const updateInvoicePONumber = ({ configId, poNumber }) => {
  return {
    type: 'UPDATE_INVOICE_PO_NUMBER',
    payload: { configId, poNumber },
  };
};

// submit invoice data
export const submitInvoiceDataAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_INVOICE_DATA_REQUEST });
    const { response, error } = await apiRequest({
      method: 'POST',
      url: 'submitInvoice',
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: SUBMIT_INVOICE_DATA_SUCCESS });
      if (successCallback) successCallback(response?.data?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: SUBMIT_INVOICE_DATA_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

export const sendSubmittedInvoiceEmailAction = ({ payload, successCallback, failureCallback }) => {
  return async () => {
    const { response, error } = await apiRequest({
      method: 'POST',
      url: 'sendSubmittedInvoiceEmail',
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      if (successCallback) successCallback(response?.data?.data);
    } else if (failureCallback) {
      failureCallback(error?.response?.data?.message || 'Failed to send invoice email');
    }
  };
};

// get invoice data
export const getInvoiceDataAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: GET_INVOICE_DATA_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getSubmittedInvoice',
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_INVOICE_DATA_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_INVOICE_DATA_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// get all inovoice data
export const getAllInvoiceDataAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: GET_ALL_INVOICE_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getAllSubmittedInvoice',
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_ALL_INVOICE_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback(response?.data?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_ALL_INVOICE_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

export const updateSubmittedInvoicePaymentStatusAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async () => {
    const { response, error } = await apiRequest({
      method: 'PATCH',
      url: 'updateSubmittedInvoicePaymentStatus',
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      successCallback?.(response?.data?.data);
    } else {
      failureCallback?.(error?.response?.data?.message || 'Failed to update invoice status');
    }
  };
};

// dismiss client changes
export const dismissClientChangesAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: DISMISS_CLIENT_CHANGES_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'updateEventEditedByClient',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: DISMISS_CLIENT_CHANGES_SUCCESS });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DISMISS_CLIENT_CHANGES_FAILURE });
      failureCallback?.();
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Error',
          message: error?.response?.data?.message || 'Failed to update status',
        }),
      );
    }
  };
};

// fetch submitted invoices
export const fetchSubmittedInvoiceAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_SUBMITTED_INVOICE_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getSubmittedLatestConfigInvoice',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_SUBMITTED_INVOICE_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_SUBMITTED_INVOICE_FAILURE });
      failureCallback?.();
    }
  };
};

export const switchInvoiceConfigAction = ({ configId }) => {
  return (dispatch) => {
    dispatch({ type: SWITCH_INVOICE_CONFIG, payload: configId });
  };
};

/**
 * receive deposit ivnocie amount
 */
export const getDepositInvoiceAmountAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: GET_DEPOSIT_INVOICE_AMOUNT_REQUEST });
    const { response, error } = await apiRequest({
      method: 'GET',
      url: 'getReceivedDepositAmountByEvent',
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: GET_DEPOSIT_INVOICE_AMOUNT_SUCCESS,
        payload: response?.data?.data,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_DEPOSIT_INVOICE_AMOUNT_FAILURE });
      failureCallback?.();
    }
  };
};

// add extra email
export const addExtraEmailAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: ADD_EXTRA_EMAIL_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'addExtraEmails',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: ADD_EXTRA_EMAIL_SUCCESS,
        payload: response?.data?.data?.extraContactEmails,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_EXTRA_EMAIL_FAILURE });
      failureCallback?.(error?.request?.data?.message);
    }
  };
};

// remove extra email
export const removeExtraEmailAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: REMOVE_EXTRA_EMAIL_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'removeExtraEmails',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: REMOVE_EXTRA_EMAIL_SUCCESS,
        payload: response?.data?.data?.extraContactEmails,
      });
      successCallback?.();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: REMOVE_EXTRA_EMAIL_FAILURE });
      failureCallback?.(error?.request?.data?.message);
    }
  };
};

// position terms
export const postPositionTermsAction = ({ payload, successCallback, failureCallback }) => {
  return async (dispatch) => {
    dispatch({ type: POSITION_TERM_UPDATE_REQUEST, payload });
    if (payload?.beforeCall) {
      dispatch({
        type: 'UPDATE_TERMS_OF_POSIITON',
        payload: {
          positionTerm: payload?.positions,
        },
      });
    }
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: `updatePositionTerms`,
      data: payload.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: POSITION_TERM_UPDATE_SUCCESS });
      if (!payload?.beforeCall) {
        dispatch({
          type: 'UPDATE_TERMS_OF_POSIITON',
          payload: {
            positionTerm: payload?.positions,
            // eventTerm: getMergedEventTerms({
            //   oldTerm: payload?.eventTerms,
            //   newTerm: response?.data?.updatedEventTerms,
            // }),
            eventTerm: response?.data?.updatedEventTerms,
          },
        });
      } else {
        dispatch({
          type: 'UPDATE_TERMS_OF_EVENT_AFTER_POSITION',
          payload: {
            // eventTerm: getMergedEventTerms({
            //   oldTerm: payload?.eventTerms,
            //   newTerm: response?.data?.updatedEventTerms,
            // }),
            eventTerm: response?.data?.updatedEventTerms,
          },
        });
      }
      if (successCallback) successCallback(response?.data?.updatedEventTerms);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: POSITION_TERM_UPDATE_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// clear contractor different time
export const clearContractorDifferentTimeAction = ({ payload }) => {
  return { type: CLEAR_CONTRACTOR_DIFFERENT_TIME, payload };
};

// unassign contractor from positions
export const unassignContractorFromPositionsAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UNASSIGN_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'removeAssignedContractor',
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: UNASSIGN_CONTRACTOR_SUCCESS,
        payload: response?.data?.contractorReimbursementAttached ? { Ids: [] } : payload?.data,
      });
      if (!response?.data?.contractorReimbursementAttached) {
        dispatch(
          alertDialogAciton({
            open: true,
            title: 'Success',
            message: response?.data?.message || 'Contractor unassigned successfully',
          }),
        );
      }
      successCallback?.(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UNASSIGN_CONTRACTOR_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Failure',
          message: response?.data?.message || 'Failed to unassigned contractor',
        }),
      );
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

export const unassignContractorFromPositionsAnywayAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UNASSIGN_CONTRACTOR_REQUEST });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'removeAssignedContractorAnyWay',
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UNASSIGN_CONTRACTOR_SUCCESS, payload: payload?.data });
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Success',
          message: response?.data?.message || 'Contractor unassigned successfully',
        }),
      );
      successCallback?.(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UNASSIGN_CONTRACTOR_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Failure',
          message: response?.data?.message || 'Failed to unassigned contractor',
        }),
      );
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * update positions for california contractor rate on event click
 */
export const updatePositionsForCaliforniaContratorForEvent = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: CALIFORNIA_CONTRACTOR_RATE_EVENT_REQUEST,
      payload: payload?.data?.fieldsToUpdate?.map((item) => item?.id),
    });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'updateRateForMulPositions',
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({ type: CALIFORNIA_CONTRACTOR_RATE_EVENT_SUCCESS });
      dispatch({
        type: 'UPDATE_CA_CONTRACTOR_RATE_OF_POSITION',
        payload: payload?.data?.fieldsToUpdate,
      });
      successCallback?.(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CALIFORNIA_CONTRACTOR_RATE_EVENT_FAILURE });
      failureCallback?.(error?.response?.data?.message);
    }
  };
};

/**
 * update the state of assignContractorTab
 */
export const updateAssignContractorTabMetaData = ({ payload }) => {
  return { type: ASSIGN_COORDINATOR_META_DATA, payload };
};

/**
 * update the state of session maangement tab
 */
export const updateSessionMangementTabMetaData = ({ payload }) => {
  return { type: SESSION_MANAGEMENT_META_DATA, payload };
};

// // refresh rate list for event
// export const refreshRateListForEventAction = ({
//   payload,
//   successCallback,
//   failureCallback,
// }) => {
//   return async (dispatch) => {
//     dispatch({ type: REFRESH_RATE_LIST_FOR_EVENT_REQUEST });
//     const { response, error } = await apiRequest({
//       method: "",
//       url: "",
//       data: payload?.data,
//       params: payload?.params,
//       isToken: true,
//       version: "v4",
//     });
//
//     if (response?.status == 200) {
//       dispatch({ type: REFRESH_RATE_LIST_FOR_EVENT_SUCCESS });
//       dispatch(refreshEventAction({ eventId: payload?.eventId }));
//       successCallback?.(response);
//     } else if (response?.status !== 200 || error) {
//       dispatch({ type: REFRESH_RATE_LIST_FOR_EVENT_FAILURE });
//       failureCallback?.(error);
//     }
//   };
// };

/**
 * add or update client and contractors applied rate at once
 *
 * api/v4/addUpdateClientContractorRates
 
Method=Put
Payload
{
    "Ids":[{"Id":"69136de60cadd689f2ce2d25","updatedContractorRate":6,"californiaContractorRate":8,"clientPreferredRate":8,"clientNotes":"clientNotes"}]
}
 */
export const addUpdateClientContractorRatesAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: ADD_UPDATE_CLIENT_CONTRACTOR_RATE_REQUEST,
      payload: {
        Ids: payload?.data?.Ids?.map((I) => I?.Id),
        disableWholeLoader: payload?.disableWholeLoader,
      },
    });
    const { response, error } = await apiRequest({
      method: 'PUT',
      url: 'addUpdateClientContractorRates',
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status == 200) {
      dispatch({
        type: ADD_UPDATE_CLIENT_CONTRACTOR_RATE_SUCCESS,
        payload: {
          disableWholeLoader: payload?.disableWholeLoader,
          Ids: payload?.data?.Ids?.map((I) => I?.Id),
        },
      });
      successCallback?.(response);
    } else if (response?.status !== 200 || error) {
      dispatch({
        type: ADD_UPDATE_CLIENT_CONTRACTOR_RATE_FAILURE,
        payload: {
          disableWholeLoader: payload?.disablewholeLoader,
        },
      });
      dispatch(
        alertDialogAciton({
          open: true,
          title: 'Error',
          message: error?.response?.data?.message ?? 'Failed to save data.',
        }),
      );
      failureCallback?.(error?.response);
    }
  };
};

/**
 * udpate po update neede key
 */
export const updatePOUpdateNeededAction = ({ payload }) => {
  return { type: UPDATE_PO_UPDATE_NEEDED_KEY, payload };
};
